import { Link } from 'react-router-dom';
import { LegalPage } from './LegalPage';
import { LEGAL_VERSIONS } from '@makhe/shared';

export default function CookiePolicyPage() {
  return (
    <LegalPage title="Cookie Policy" lastUpdated={LEGAL_VERSIONS.cookiePolicy}>
      <p>
        This policy explains how Makhe uses cookies and similar technologies. See also our{' '}
        <Link to="/legal/privacy">Privacy Policy</Link>.
      </p>

      <h2>1. Essential cookies</h2>
      <p>
        Required for authentication, session management, and security. The app cannot function
        without these.
      </p>

      <h2>2. Preference cookies</h2>
      <p>
        Store choices such as theme (light/dark) and cookie consent preferences in your browser
        local storage.
      </p>

      <h2>3. Analytics</h2>
      <p>
        Firebase Analytics and PostHog help us understand feature usage and improve the product.
        You can opt out of non-essential analytics via the cookie banner on first visit.
      </p>

      <h2>4. Error reporting</h2>
      <p>
        Sentry collects anonymised error reports to fix bugs. We minimise personal data in error
        payloads.
      </p>

      <h2>5. Managing cookies</h2>
      <p>
        Use the cookie banner to accept or decline optional analytics. You can clear site data in
        your browser settings; you may need to sign in again.
      </p>
    </LegalPage>
  );
}
